// extracted by mini-css-extract-plugin
export var filterIncDec = "_bj-0";
export var leftBorder = "_bj-1";
export var rightBorder = "_bj-2";
export var stringInput = "_bj-3";